const environment = {
    test: 'test',
    production: 'production',
};

export default environment;
